import { InjectionToken } from '@angular/core';
import { Category } from '.';
import { FilterFieldValue } from '../covance-filter';
import { Observable } from 'rxjs';

export interface DocumentsStorage {
    loadDocumentsByCategory(category: Category, filterParameters: FilterFieldValue[]): Observable<any[]>;
}

export const DOCUMENTS_STORAGE = new InjectionToken<DocumentsStorage>('DocumentsLoaderForFilteredGrid');
